module.exports = __webpack_public_path__ + "static/Gilroy-Medium-7ab5484c73169bf74b17343ed54799ef.woff";